import React, { useEffect, useState } from 'react'
import { AppHeader } from 'src/business/components'
import { AiOutlineRight } from 'react-icons/ai'
import billing from 'src/assets/billing.png'
import { FaChevronCircleRight } from 'react-icons/fa'
import { FaSortUp } from 'react-icons/fa'
import { FaSortDown } from 'react-icons/fa'
import { BsCheckLg } from 'react-icons/bs'
import {
  CTableDataCell,
  CFormCheck,
  CTable,
  CTableHead,
  CTableHeaderCell,
  CTableBody,
  CTableRow,
  CSpinner,
} from '@coreui/react-pro'
import { subscriptionPlanDetails } from 'src/business/services/APIs/SubscriptionPlan/subscriptionPlanDetails'
import { getCustomerDetails } from 'src/business/services/APIs/Customer/CustomerDetails'
const BillingAndPlans = ({ heading }) => {
  const [plan, setPlan] = useState()
  const [details, setDetails] = useState()
  const [id, setId] = useState()
  const [title, setTitle] = useState()
  const [desc, setDesc] = useState()
  const [date, setNDate] = useState()
  const [validity, setValidity] = useState()
  const [billingEmail, setBillingEmail] = useState()
  const [vatNumber, setVatNumber] = useState()
  const [companyName, setCompanyName] = useState()
  const [loading, setLoading] = useState(false)

  const customerDetails = async () => {
    setLoading(true)
    const response = await getCustomerDetails()
    setDetails(response.data)
    setId(response.data.packageId)
    setBillingEmail(response.data.billingDetails.attnEmailId)
    setVatNumber(response.data.billingDetails.vatNumber)
    setCompanyName(response.data.companyName)
    sessionStorage.setItem('id', response.data.packageId)
    setLoading(false)
  }

  const planDetails = async () => {
    setLoading(true)
    const response = await subscriptionPlanDetails(id)
    setPlan(response.data)
    setTitle(response.data.title)
    setDesc(response.data.description)
    const dateadd = new Date(response.data.createdTime)
    const myDate =
      dateadd.getUTCDate() + '/' + (dateadd.getMonth() + 1) + '/' + dateadd.getUTCFullYear()
    setNDate(myDate)
    setValidity(response.data.validity)
    setLoading(false)
  }

  useEffect(() => {
    customerDetails()
    planDetails()
  }, [])

  const data = [
    {
      id: 1,
      amount: 400,
      recipient: 'Jon Snow',
      date: '26/7/2022',
      status: 'Active',
      paymentMethod: 'Razorpay',
    },
    {
      id: 2,
      amount: 400,
      recipient: 'Jon Snow',
      date: '26/7/2022',
      status: 'Active',
      paymentMethod: 'Razorpay',
    },
    {
      id: 3,
      amount: 400,
      recipient: 'Jon Snow',
      date: '26/7/2022',
      status: 'Active',
      paymentMethod: 'Razorpay',
    },
    {
      id: 4,
      amount: 400,
      recipient: 'Jon Snow',
      date: '26/7/2022',
      status: 'Active',
      paymentMethod: 'Razorpay',
    },
    {
      id: 5,
      amount: 400,
      recipient: 'Jon Snow',
      date: '26/7/2022',
      status: 'Active',
      paymentMethod: 'Razorpay',
    },
  ]
  return (
    <div>
      <AppHeader heading="Billing and Plans" />
      {loading ? (
        <CSpinner className={loading ? `block p-4 m-4` : `hidden`} />
      ) : (
        <div>
          <div className="flex flex-col lg:flex-row gap-4 w-full px-16 mt-12">
            <div className="w-full lg:w-4/6 bg-cardLight dark:bg-cardDark h-64 p-4 mb-8 rounded-xl shadow-xl">
              <div className="flex flex-col h-full justify-between">
                <div className="flex flex-col ">
                  <div className="flex flex-row justify-between px-4">
                    <p className="font-black text-lg text-iconCol dark:text-white dark:text-white">
                      Current Subscription Plan
                    </p>
                    <p className="text-lg dark:text-white">{title}</p>
                  </div>
                  <div className="flex flex-row justify-between px-4">
                    <p className="font-black text-lg text-iconCol dark:text-white dark:text-white">
                      Plan Start Date
                    </p>
                    <p className="text-lg">{date}</p>
                  </div>
                  <div className="flex flex-row justify-between px-4">
                    <p className="font-black text-lg text-iconCol dark:text-white dark:text-white">
                      Plan Validity
                    </p>
                    <p className="text-lg dark:text-white">{validity} days</p>
                  </div>
                </div>
                <div className="flex dark:text-white px-4 flex-col">
                  <div className="flex flex-row gap-2 items-center">
                    <i className="text-green-600">
                      <BsCheckLg />
                    </i>
                    <p className="mb-0 text-blue-500 dark:text-white">{desc}</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                background: `url(${billing})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
              className="w-6/12 mx-auto lg:w-4/12 p-4 mb-8 rounded-xl shadow-xl"
            >
              <div className="-ml-3">
                <p className="text-gray-300 font-black text-xl">Next Payment</p>
              </div>
              <div>
                <p className="text-5xl text-white ">$ 320.62</p>
              </div>
              <div>
                <p className="text-2xl text-white ">
                  on <span className="font-black">June 24, 2022</span>
                </p>
              </div>
              <div className="w-full">
                <button
                  style={{
                    background: 'rgba(26, 26, 26, 0.65)',
                    boxShadow: '5px 5px 9px rgba(0, 0, 0, 0.25)',
                    backdropFilter: 'blur(2px)',
                  }}
                  className=" p-2 px-auto w-1/2 rounded-full text-white"
                >
                  <div className="flex flex-row w-max mx-auto items-center gap-2">
                    Manage
                    <i>
                      <FaChevronCircleRight />
                    </i>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className=" w-full px-16">
            <div className="w-full bg-cardLight dark:bg-cardDark h-auto p-4 mb-8 rounded-xl shadow-xl">
              <h2 className="text-textHeading dark:text-white font-black">Payment Information</h2>
              <div className="flex flex-col gap-4 lg:gap-0 lg:flex-row px-2 my-4">
                <div
                  style={{
                    background: 'linear-gradient(31.58deg, #93278F -2.49%, #6877E0 67.92%)',
                  }}
                  className="w-96 rounded-3xl mx-auto h-52"
                >
                  <div>
                    <div className="flex flex-row justify-between w-full p-4">
                      <div>
                        <img src="card_chip.png" />
                      </div>
                      <div>
                        <img src="visa.png" />
                      </div>
                    </div>
                    <div className="w-full text-center text-white my-2">
                      <h1>**** **** **** ****</h1>
                    </div>
                    <div className="flex flex-row justify-between text-white w-full p-2 px-4">
                      <div className="flex flex-col text-left">
                        <div>{companyName}</div>
                        <div>xxxxx xxxxx xxxxx</div>
                      </div>
                      <div className="flex flex-col text-left">
                        <div>Expiry</div>
                        <div>xx/xx</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mx-auto">
                  <div className="h-full flex flex-col pl-10 justify-center">
                    <div className="flex flex-row gap-4 w-max px-4">
                      <p className="font-black text-lg text-iconCol dark:text-white">
                        Billing Email
                      </p>
                      <p className="text-lg dark:text-white">{billingEmail}</p>
                    </div>
                    <div className="flex flex-row gap-4 w-max px-4">
                      <p className="font-black text-lg text-iconCol dark:text-white">
                        GST/VAT Number
                      </p>
                      <p className="text-lg dark:text-white">{vatNumber}</p>
                    </div>
                    <div className="flex flex-row gap-4 w-max px-4">
                      <p className="font-black text-lg text-iconCol dark:text-white">
                        Renewal Date
                      </p>
                      <p className="text-lg dark:text-white">26/09/2023</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full px-4 py-4">
              <h2 className="text-textHeading dark:text-white font-black">Payment History</h2>
              <div>
                <CTable align="middle" className="my-4 bg-transparent" hover responsive>
                  <CTableHead>
                    <CTableRow></CTableRow>
                    <CTableRow style={{ background: '#F9F9F9' }} className="text-lg">
                      <CTableHeaderCell className="border-none bg-transparent">
                        <div className=" my-3">
                          <CFormCheck />
                        </div>
                      </CTableHeaderCell>
                      <CTableHeaderCell className="text-gray-900 bg-transparent py-4 font-black border-none">
                        <div className="flex flex-row gap-2 w-max mx-auto items-center">
                          <p className="mb-0">Amount</p>
                          <span className="flex flex-col gap-0">
                            <i>
                              <FaSortUp />
                            </i>
                            <i className="-mt-4">
                              <FaSortDown />
                            </i>
                          </span>
                        </div>
                      </CTableHeaderCell>
                      <CTableHeaderCell className="text-gray-900 py-4 bg-transparent font-black border-none">
                        <div className="flex flex-row gap-2 mx-auto w-max items-center">
                          <p className="mb-0">Recipient</p>
                          <span className="flex flex-col gap-0">
                            <i>
                              <FaSortUp />
                            </i>
                            <i className="-mt-4">
                              <FaSortDown />
                            </i>
                          </span>
                        </div>
                      </CTableHeaderCell>
                      <CTableHeaderCell className="text-gray-900 py-4 bg-transparent font-black border-none">
                        <div className="flex flex-row gap-2 w-max mx-auto items-center">
                          <p className="mb-0">Date</p>
                          <span className="flex flex-col gap-0">
                            <i>
                              <FaSortUp />
                            </i>
                            <i className="-mt-4">
                              <FaSortDown />
                            </i>
                          </span>
                        </div>
                      </CTableHeaderCell>
                      <CTableHeaderCell className="text-gray-900 py-4 bg-transparent font-black border-none">
                        <div className="flex flex-row gap-2 w-max mx-auto items-center">
                          <p className="mb-0">Status</p>
                          <span className="flex flex-col gap-0">
                            <i>
                              <FaSortUp />
                            </i>
                            <i className="-mt-4">
                              <FaSortDown />
                            </i>
                          </span>
                        </div>
                      </CTableHeaderCell>
                      <CTableHeaderCell className="text-gray-900 py-4 bg-transparent font-black border-none">
                        <div className="flex flex-row gap-2 w-max mx-auto items-center">
                          <p className="mb-0">Payment Method</p>
                          <span className="flex flex-col gap-0">
                            <i>
                              <FaSortUp />
                            </i>
                            <i className="-mt-4">
                              <FaSortDown />
                            </i>
                          </span>
                        </div>
                      </CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {data.map((item) => {
                      return (
                        <tr className="text-lg" key={item.id}>
                          <CTableDataCell className="border-none py-4">
                            <div>
                              <CFormCheck />
                            </div>
                          </CTableDataCell>
                          <CTableDataCell className="border-none py-4 text-center text-gray-900 dark:text-white">
                            <div>${item.amount}</div>
                          </CTableDataCell>
                          <CTableDataCell className="text-gray-900 dark:text-white py-4 text-center border-none">
                            <div>{item.recipient}</div>
                          </CTableDataCell>
                          <CTableDataCell className="text-gray-900 dark:text-white py-4 text-center border-none">
                            {item.date}
                          </CTableDataCell>
                          <CTableDataCell className="text-gray-900 py-4 border-none text-center">
                            <div className="bg-green-100 w-max mx-auto p-1 text-sm px-2 rounded-xl text-center">
                              {item.status}
                            </div>
                          </CTableDataCell>
                          <CTableDataCell className="text-gray-900 dark:text-white text-center border-none">
                            <div>{item.paymentMethod}</div>
                          </CTableDataCell>
                        </tr>
                      )
                    })}
                  </CTableBody>
                </CTable>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default BillingAndPlans
